class LangSelector extends HHBaseElement {
  constructor() {
    super();

    this.countrySelector = this.querySelector('.js-country-selector')

    // The country the page is currently rendered in, so re-picking it is a no-op.
    this.currentIso = (this.countrySelector
      ?.querySelector('[aria-selected="true"]')
      ?.dataset?.isoCode || '').toUpperCase()

    // custom-dropdown.js dispatches countryChanged from selectOption(), which covers
    // click, Enter/Space and select-on-blur. There is no Apply button in this design,
    // so a real change navigates straight away.
    document.addEventListener('countryChanged', this.onCountryChanged.bind(this))
  }

  connectedCallback() {
    this._setupFocusTrap(this.closest('modal-dialog'))
  }

  onCountryChanged() {
    const option = this.countrySelector?.querySelector('[aria-selected="true"]')
    const iso = (option?.dataset?.isoCode || '').toUpperCase()

    // Guard against select-on-blur: closing the dropdown without moving the highlight
    // re-selects the current country, and reloading the same market is pointless.
    if (!iso || iso === this.currentIso) return

    this.submit(option)
  }

  // Keep the current language if the destination market offers it, otherwise use that
  // market's first configured language.
  getLanguageForCountry(option) {
    const languages = (option?.dataset?.languages || 'en')
      .split(',')
      .map((lang) => lang.trim().toLowerCase())
      .filter(Boolean)

    if (languages.length === 0) return 'en'

    const current = (window.Shopify?.locale || '').toLowerCase()
    if (current && languages.includes(current)) return current

    return languages[0]
  }

  submit(countryOption) {
    const option = countryOption
      || this.countrySelector?.querySelector('[aria-selected="true"]')
    const countryUrl = option?.dataset?.href
    if (!countryUrl) return

    const language = this.getLanguageForCountry(option)
    window.location.href = countryUrl.replace('en-', `${language}-`)
  }
}

window.customElements.define('lang-selector', LangSelector);
